import { CanopyProvider } from '@bloomfieldrobotics/canopy';
import { Box, Typography, useTheme } from '@mui/material';
import { useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { selectRanchSummaryTableNumRowsSelected } from '../dataGridTablesSlice';
import DownloadTableButton from '../DownloadTableButton';
import SearchBarDataGrid from '../SearchBarDataGrid';
import RanchSummaryTableDropdowns from './RanchSummaryTableDropdowns';
interface Props {
  onDownloadClick: () => void;
}

const RanchSummaryTableHeader: React.FC<Props> = ({ onDownloadClick }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const numRowsSelected = useAppSelector(
    selectRanchSummaryTableNumRowsSelected
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          p: '1.25rem 1.5rem 0.75rem 1.5rem',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <Typography
            sx={{
              fontSize: '1.125rem',
              fontWeight: 700,
              color: theme.colors.canopy.content.primary,
            }}
          >
            {t('Scan History')}
          </Typography>
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: theme.colors.canopy.content.secondary,
            }}
          >
            {t('Summary of all scans')}
          </Typography>
        </Box>
        <DownloadTableButton
          onDownloadClick={onDownloadClick}
          numRowsSelected={numRowsSelected}
        />
      </Box>
      <Box
        sx={{
          width: '100%',
          p: '0.75rem 1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <Box sx={{ width: '100%' }}>
          <SearchBarDataGrid />
        </Box>
        <CanopyProvider>
          <RanchSummaryTableDropdowns />
        </CanopyProvider>
      </Box>
    </Box>
  );
};

export default RanchSummaryTableHeader;
